import api from '@/api';

import { PageRequest } from '@/core/request/PageRequest';
import { PageResult } from '@/core/request/PageResult';

import {
  CreatePartRequest,
  Part,
  PartCreateMultipleRequest,
  UpdatePartRequest,
} from './Parts.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/parts`;

export async function listParts(
  params: PageRequest,
): Promise<PageResult<Part>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<Part>;
}

export async function partValidBarCode(params: {
  barCode: string;
  partId?: number;
}) {
  const result = (await api.get(`${CONTROLLER_URL}`, {
    barCode: params.barCode,
  })) as unknown as PageResult<Part>;

  return (
    !!result.data.length &&
    !result.data.some((item) => item.id === params.partId)
  );
}

export async function getPart(partId?: number): Promise<Part> {
  const result = (await api.get(
    `${CONTROLLER_URL}/${partId}`,
    null,
  )) as unknown;

  return result as Part;
}

export async function createPart(obj: CreatePartRequest): Promise<Part> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Part;
}

export async function createMultiplePart(obj: PartCreateMultipleRequest) {
  const result = (await api.post(
    `${CONTROLLER_URL}/batch`,
    obj,
    null,
  )) as unknown;

  return result as Part[];
}

export async function updatePart(obj: UpdatePartRequest): Promise<Part> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Part;
}

export async function deletePart(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function activeInactivePart(id: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${id}/active`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function validateManufacturingCode(obj: {
  manufacturingCode: string;
  partId?: number;
}) {
  const result = (await api.get(`${CONTROLLER_URL}/validate`, obj)) as unknown;

  return result as boolean;
}
